var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tai-xiu-full-video" },
    [
      _vm.playerKind === "canvas"
        ? _c("TCVideo", {
            key: "tcvideo",
            staticClass: "tai-xiu-full-video__player",
            attrs: {
              videoPlayerReady: true,
              "arena-id": _vm.arenaId,
              embedded: "",
            },
          })
        : _vm.playerKind === "tcplayer"
        ? _c("TCVideoV1", {
            key: "tcvideov1",
            staticClass: "tai-xiu-full-video__player",
            attrs: {
              videoPlayerReady: true,
              "arena-id": _vm.arenaId,
              embedded: "",
            },
          })
        : [
            _c("VePlayerVideo", {
              staticClass: "tai-xiu-full-video__player",
              attrs: { "arena-id": _vm.arenaId, embedded: "" },
              on: {
                "update:videoPlayerReady": function ($event) {
                  _vm.isPlaying = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "no-stream",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "tai-xiu-full-video__feed",
                        attrs: { src: _vm.placeholder, alt: "" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm.streamUrl && !_vm.isPlaying
              ? _c("img", {
                  staticClass:
                    "tai-xiu-full-video__feed tai-xiu-full-video__cover",
                  attrs: { src: _vm.placeholder, alt: "" },
                })
              : _vm._e(),
          ],
      _c("VideoToast", {
        attrs: {
          toast: _vm.tableId ? _vm.videoToast(_vm.tableId) : null,
          source: _vm.tableId,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }